import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './HeroSection.css';
import { ArrowUpRightIcon} from '../Icons';
import Hero1  from '../../assets/Home/Hero1.png';

const slidesData = [
  {
    id: '01',
    tagline: 'Welcome to DEXA Innovation',
    title: 'Empowering Manufacturing with Precision CNC Solutions',
    description: 'DEXA Innovation delivers advanced CNC and industrial machinery designed to improve productivity, accuracy, and efficiency. From machine selection to installation and after-sales support, we help manufacturers achieve reliable performance and long-term success.',
    ctaText: 'Explore Machines',
    ctaLink: '/services',
    cardCategory: '1. CNC Machinery',
    cardCounter: '01 / 03',
    cardTitle: 'High-Performance Industrial Machines for Every Manufacturing Need',
    cardLinkText: 'View Products',
    bgImage: Hero1
  },
  {
    id: '02',
    tagline: 'Advanced Cutting Technology',
    title: 'Next-Gen Fiber Laser & Precision Cutting Systems',
    description: 'Experience unmatched speed, minimal material waste, and micro-precision accuracy for industrial fabrication and heavy-duty manufacturing projects tailored to modern engineering.',
    ctaText: 'Discover Solutions',
    ctaLink: '/solutions',
    cardCategory: '2. Laser Cutting',
    cardCounter: '02 / 03',
    cardTitle: 'Ultra-Precision Metal & Heavy Sheet Cutting Laser Systems',
    cardLinkText: 'Explore Lasers',
    bgImage: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1920&q=85'
  },
  {
    id: '03',
    tagline: 'Smart Factory Automation',
    title: 'Automated Robotic Systems & Intelligent CNC Hubs',
    description: 'Optimize workflow efficiency with fully integrated robotic arms, automated tool changers, and real-time smart monitoring for zero-downtime high-speed production.',
    ctaText: 'Learn More',
    ctaLink: '/about',
    cardCategory: '3. Smart Automation',
    cardCounter: '03 / 03',
    cardTitle: 'Complete Turnkey Automation Solutions for Next-Gen Manufacturing',
    cardLinkText: 'View Automation',
    bgImage: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1920&q=85'
  }
];

const HeroSection = () => {
  const [currentSlideIndex] = useState(0);
  const navigate = useNavigate();

  const currentSlide = slidesData[currentSlideIndex];

  return (
    <section className="hero-section">
      {/* Background Image Container */}
      <div 
        className="hero-bg-container"
        style={{ 
          backgroundImage: `url(${currentSlide.bgImage})`
        }}
      />

      {/* Hero Main Content */}
      <div className="hero-content-wrapper">
        <div className="hero-main-content animate-fade-in" key={currentSlide.id}>
          {/* Tagline */}
          <div className="hero-tagline">
            <span>{currentSlide.tagline}</span>
          </div>

          {/* Main Headline */}
          <h1 className="hero-title">
            {currentSlide.title}
          </h1>

          {/* Paragraph Description */}
          <p className="hero-description">
            {currentSlide.description}
          </p>

          {/* Primary CTA Button */}
          <div className="hero-actions">
            <button className="hero-cta-btn" onClick={() => navigate(currentSlide.ctaLink)}>
              <span>{currentSlide.ctaText}</span>
              <span className="hero-cta-badge">
                <ArrowUpRightIcon size={16} color="#F9541B" />
              </span>
            </button>
          </div>

          {/* Slider Arrow Controls */}
          {/* <div className="slider-controls">
            <button 
              className="slider-arrow-btn" 
              onClick={handlePrevSlide} 
              aria-label="Previous Slide"
            >
              <ChevronLeftIcon size={20} />
            </button>
            <button 
              className="slider-arrow-btn" 
              onClick={handleNextSlide} 
              aria-label="Next Slide"
            >
              <ChevronRightIcon size={20} />
            </button>
          </div> */}
        </div>
      </div>

      {/* Floating Card - Overlapping Hero & Stats Bar */}
      <div className="hero-floating-card animate-fade-in" key={`card-${currentSlide.id}`}>
        <div className="card-top-meta">
          <span className="card-category">{currentSlide.cardCategory}</span>
          <span className="card-counter">{currentSlide.cardCounter}</span>
        </div>

        <h3 className="card-title">
          {currentSlide.cardTitle}
        </h3>

        <div className="card-divider" />

        <Link to="/services" className="card-footer-link">
          <span>{currentSlide.cardLinkText}</span>
          <div className="card-arrow-circle">
            <ArrowUpRightIcon size={14} color="#FFFFFF" />
          </div>
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
